export const FORMULA_MATE_SESSION_ID = '747bfa31-5837-46bd-a752-0907fa989102';

export const FORMULA_MATE_PROMPTS = [
  'Generate a Python formula to calculate the average of the last five sensor readings.',
  'Create a formula to calculate the percentage deviation between the actual value and the target value.',
  'Generate a formula to calculate the difference between two sensor values.',
] as const;
